class StorageManager {
  write(key, data, options = {}) {
    this.throwIfKeyIsNotString(key)

    if (options.useSessionStorage) {
      sessionStorage.setItem(key, JSON.stringify(data))
    } else {
      localStorage.setItem(key, JSON.stringify(data))
    }

    return true
  }

  read(key, options = {}) {
    this.throwIfKeyIsNotString(key)

    const itemValue = options.useSessionStorage
      ? sessionStorage.getItem(key)
      : localStorage.getItem(key)

    try {
      return JSON.parse(itemValue)
    } catch (e) {
      return itemValue
    }
  }

  throwIfKeyIsNotString = (key) => {
    if (typeof key !== 'string') {
      throw new Error(
        `read method expects a key string, received + ${JSON.stringify(key)}`
      )
    }
  }

  remove(key, options = {}) {
    this.throwIfKeyIsNotString(key)

    if (options.useSessionStorage) {
      sessionStorage.removeItem(key)
    } else {
      localStorage.removeItem(key)
    }

    return true
  }
}

export default new StorageManager()
